import { FieldModel, ProgramBenchmarkName, ProgramTask, TaskDataTraitStatus } from '@cibo/core'
import { BiomassBurningCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface BiomassBurningCellProps {
  value: any
  task: ProgramTask<{ benchmarkName: ProgramBenchmarkName; traits: TaskDataTraitStatus[] }>
  year: number
  selectedField?: FieldModel
  onSaveSuccess?: () => void
}

export const BiomassBurningCell = ({
  value,
  task,
  year,
  selectedField,
  onSaveSuccess,
}: BiomassBurningCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="biomassBurning"
      onSaveSuccess={onSaveSuccess}
    >
      <BiomassBurningCellDisplay value={value} />
    </TraitCellContainer>
  )
}
